import React from 'react';
import axios from 'axios';
import { zip } from 'lodash';
import RulerCm from './RulerCm';
import { API_HOST } from '../consts';

class ReguaProficiencia extends React.Component {
  getItemLink(s, analise) {
    axios
      .get(
        `${API_HOST}/itens/item/${analise.avaliacao.id}/proficiency_scale_item_link?q=${s}`
      )
      .then((res) => {
        if (res.data.endpoint) {
          window.open(`${res.data.endpoint}`, '_blank');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  renderQ(s) {
    const { analise } = this.props;
    if (s && analise) {
      this.getItemLink(s, analise);
    } else return '-';
  }

  render() {
    const { data } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              <table className="table regua-pro">
                <thead>
                  <tr>
                    {data.map((r) => (
                      <th width="50px" className="ruler-cm" key={r[0]}>
                        <RulerCm />
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {data.map((r) => (
                      <th width="50px" className="below-ruler" key={r[0]}>
                        {r[0]}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {zip(...data)
                    .slice(1)
                    .map((r, i) => (
                      <tr key={i}>
                        {r.map((s, j) => (
                          <td width="30px" key={j}>
                            {s ? (
                              <button
                                className="btn btn-default btn-nobackgorund"
                                onClick={() => this.renderQ(s)}
                              >
                                <u>{s}</u>
                              </button>
                            ) : (
                              '-'
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReguaProficiencia.defaultProps = {
  data: []
};

export default ReguaProficiencia;
